// src/components/ScrollToTop.js
// React Router doesn't scroll to top on navigation by default (unlike a traditional multi-page
// site) -- every Link (footer, header, "Read more" cross-page links, etc.) would otherwise leave
// the viewport wherever it happened to be scrolled to on the previous page. Rendered once inside
// <Router> so it applies to every navigation, not just footer links specifically.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
